// Types
import { StepApiResponseType } from 'types/step-api-response.type';

type ContractApiDataApiResponseType = StepApiResponseType & {
  amount: number;
  currency: string;
  totalAmount: number;
  totalInterestAmount: number;
  interestRate: number;
  nominalInterest: number;
  installmentAmount: number;
  installmentsNumber: number;
  precontractualId: string;
  precontractualUrl: string;
  paymentMethod: string;
  accounts: {
    iban: string;
    selected: boolean;
  }[];
  consents: [
    {
      type: ContractConsentsTypeEnum;
      visible: true;
    }
  ];
};

type PreContractApiDataApiResponseType = StepApiResponseType & {
  amount: number;
  currency: string;
  totalAmount: number;
  totalInterestAmount: number;
  interestRate: number;
  nominalInterest: number;
  installmentAmount: number;
  installmentsNumber: number;
  precontractualId: string;
  precontractualUrl: string;
  paymentMethod: string;
  accounts: [
    {
      iban: string;
      selected: true;
    }
  ];
  consents: [
    {
      type: ContractConsentsTypeEnum;
      visible: true;
    }
  ];
};

enum ContractConsentsTypeEnum {
  PAYMENT_METHOD_STORAGE = 'PAYMENT_METHOD_STORAGE',
  DATA_SHARING = 'DATA_SHARING',
  SEPA_MANDATE = 'SEPA_MANDATE',
  TERMS_AND_AGREEMENT = 'TERMS_AND_AGREEMENT',
  PARTNER_DATA_STORAGE = 'PARTNER_DATA_STORAGE',
}

export {
  ContractApiDataApiResponseType,
  PreContractApiDataApiResponseType,
  ContractConsentsTypeEnum,
};
